"use client";

import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ComplianceNote() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="compliance-note" className="bg-secondary text-secondary-foreground py-16 md:py-24">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 max-w-4xl text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-default mb-6 text-white">
          Marking Built to the Standards Specifiers Write Against
        </h2>
        
        <p className="text-base md:text-lg leading-relaxed mb-8 text-secondary-foreground/90">
          Evermark Industrial Solutions produces engraving and marking designed to align with standards such as UL 508A, NFPA 70E, NEC 110.16, ANSI Z535, and MIL-SPEC phenolic specifications when the labels are properly specified for the installation. Code compliance always depends on the specific application, the data on the label, and field conditions, so Evermark recommends confirming requirements with the engineer of record or a qualified specialist for any safety-critical labeling.
        </p>
        
        
      </div>
    </section>;
}